import { Input, Select } from "antd"
import React, { useRef } from "react"
import CustomRangePicker from "src/components/CustomRangePickerMobile/CustomRangePicker"
import Button from "src/components/MyButton/Button"
import SvgIcon from "src/components/SvgIcon"
import { InputSearchStyle } from "../../../Setting/common/styled"
import SelectProvider from "src/components/Dropdown/SelectProvider"
import SelectPackage from "src/components/Dropdown/SelectPackage"
import SelectCustomer from "src/components/Dropdown/SelectCustomer"
import SelectCarrier from "src/components/Dropdown/SelectCarrier"
import SelectSimType from "src/components/Dropdown/SelectSimType"

const FilterData = ({filter, setFilter,setKeyword}) => {
  const inputSearchRef = useRef()
  const onSearch = () => {
    const keyword = inputSearchRef.current || "";
      setKeyword(keyword); 
  };
  const onClearSearch = () => {
    inputSearchRef.current = ""; 
    setKeyword(""); 
  };

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 16,
        minWidth: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 12,
          maxWidth: "1000px",
        }}
      >
        {/* <Select
          placeholder={<span style={{ color: "#bfbfbf" }}>Trạng thái</span>}
          allowClear
          style={{ width: 150 }}
          onChange={val => setFilter(prev => ({ ...prev, status: val }))}
        >
          <Select.Option value="3">Đã kích hoạt</Select.Option>
          <Select.Option value="2">Chưa kích hoạt</Select.Option>
          <Select.Option value="1">Đã bán</Select.Option>
          <Select.Option value="0">Tồn kho</Select.Option>
        </Select> */}
        {/* <SelectSimType  style={{ width: 150 }} onChange={val => setFilter(prev => ({ ...prev, sim_type: val }))}/> */}
        <SelectProvider  style={{ width: 150 }} onChange={val => setFilter(prev => ({ ...prev, supplier_id: val }))}/>
        <SelectCarrier style={{ width: 150 }} onChange={val => setFilter(prev => ({ ...prev, network_id: val }))}/>
        {/* <SelectCustomer style={{ width: 150 }} /> */}
        {/* <SelectPackage style={{ width: 180 }} onChange={val => setFilter(prev => ({ ...prev, package_id: val }))}/> */}
        {/* <CustomRangePicker style={{ width: 250 }} format="DD/MM/YYYY" /> */}
      </div>
      <div>
        <InputSearchStyle>
          <Input
            allowClear
            className="custom-input"
            maxLength={50}
            placeholder="Mã lô nhập"
            onChange={e => (inputSearchRef.current = e.currentTarget.value)}
            onPressEnter={onSearch}
            onClear={onClearSearch}
            size="small"
          />
          <div className="custom-icon-search">
            <SvgIcon name="searchStatistic" />
          </div>
        </InputSearchStyle>
      </div>
    </div>
  )
}
export default FilterData
